import { render, staticRenderFns } from "./gasPanel.vue?vue&type=template&id=536c8734&scoped=true&"
import script from "./gasPanel.vue?vue&type=script&lang=js&"
export * from "./gasPanel.vue?vue&type=script&lang=js&"
import style0 from "./gasPanel.vue?vue&type=style&index=0&id=536c8734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536c8734",
  null
  
)

export default component.exports